import { UserRole } from "../../store/types/context";
import UserPartners from "./UserPartners";

export const userPartnersPath = "/user-partners";
export const userPartnersComponent = UserPartners;
export const userPartnersRoles = [UserRole.Admin]

